import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";

interface RoleSelectProps {
  selectedRole: string;
  onRoleChange: (role: string) => void;
}

export const RoleSelect = ({ selectedRole, onRoleChange }: RoleSelectProps) => {
  return (
    <RadioGroup
      value={selectedRole}
      onValueChange={onRoleChange}
      className="grid grid-cols-3 gap-4"
    >
      <div>
        <RadioGroupItem value="borrower" id="borrower" className="peer sr-only" />
        <Label
          htmlFor="borrower"
          className="flex flex-col items-center justify-between rounded-md border-2 border-muted bg-transparent p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary"
        >
          <span>Borrower</span>
        </Label>
      </div>
      <div>
        <RadioGroupItem value="lender" id="lender" className="peer sr-only" />
        <Label
          htmlFor="lender"
          className="flex flex-col items-center justify-between rounded-md border-2 border-muted bg-transparent p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary"
        >
          <span>Lender</span>
        </Label>
      </div>
      <div>
        <RadioGroupItem value="vendor" id="vendor" className="peer sr-only" />
        <Label
          htmlFor="vendor"
          className="flex flex-col items-center justify-between rounded-md border-2 border-muted bg-transparent p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary"
        >
          <span>Vendor</span>
        </Label>
      </div>
    </RadioGroup>
  );
};